import { L, LCategory } from "./abpUtility"
import {
  ExcelIcon,
  ImageIcon,
  MsgIcon,
  OtherFileIcon,
  PdfIcon,
  WordIcon,
  PowerPointIcon,
} from "@components/Icon"
import { useEffect, useRef } from "react"
import { localizationConst } from "./localizationConst"

export const AppConfiguration = {
  appBaseUrl: "",
  remoteServiceBaseUrl: "",
  googleMapKey: "",
  appLayoutConfig: {} as any,
}

export const validateStatus = {
  validating: "validating",
  success: "success",
  error: "error",
  warning: "warning",
}

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
  tenant: process.env.REACT_APP_FIREBASE_TENANT || "",
  client: process.env.REACT_APP_FIREBASE_CLIENT || undefined,
}
export const defaultLocation = {
  lat: 10.8230989,
  lng: 106.6296638,
}
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T | undefined>(undefined)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

export const StepOTPVariable = {
  otpOldPhone: "old-phone-otp",
  otpNewPhone: "new-phone-otp",
  newPhoneNumber: "new-phone",
}

const AppConsts = {
  vnCountryId: 232,
  noImage: "/assets/images/logo.png",
  tableMaxHeight: window.innerHeight - 440,
  tableWidth: {
    date: 130,
    shortCode: 100,
  },
  yesNoValue: [
    {
      value: "true",
      get label() {
        return L("_YES")
      },
    },
    {
      value: "false",
      get label() {
        return L("_NO")
      },
    },
  ],
  inquiryStatusOverview: [
    { id: "1", name: "New inquiry" },
    {
      id: "2",
      name: "Offer",
    },
    {
      id: "3",
      name: "Lease agreement",
    },
    {
      id: "4",
      name: "Confirmed",
    },
    {
      id: "5",
      name: "Dropped",
    },
  ],
  inquiryStatus: {
    newInquiry: {
      id: 1,
      name: "newInquiry",
    },
    offer: {
      id: 2,
      name: "offer",
    },
    leaseAgreement: {
      id: 3,
      name: "leaseAgreement",
    },
    confirmed: {
      id: 4,
      name: "confirmed",
    },
    dropped: {
      id: 5,
      name: "dropped",
    },
  },
  unitStatus: {
    vacant: 1 as const,
    leased: 2 as const,
    showRoom: 3 as const,
    renovation: 4 as const,
    pmhUse: 5 as const,
    inhouseUse: 6 as const,
    outOfOrder: 7 as const,
    outOfService: 8 as const,
  },
  documentType: {
    other: 9 as const,
    image: 8 as const,
    logo: 10 as const,
  },
  itemDashboard: {
    overView: 1,
    property: 2,
    client: 3,
    inquiry: 4,
    LA: 5,
    task: 6,
    staff: 7,
    commission: 8,
    deposit: 9,
    unitOcc: 10,
    appUsage: 11,
    performances: 12,
  },
  leaseStatus: {
    laDraft: 7,
    LaSigned: 10,
    laConfirm: 17,
  },
  leaseStage: {
    new: 1 as const,
    confirm: 2 as const,

    terminate: 3 as const,
    earlyTerminate: 4 as const,
    drop: 5 as const,
  },

  dashboardOccType: {
    date: 0 as const,
    week: 1 as const,

    month: 2 as const,
  },
  proposalTemplateType: {
    unit: 2 as const,
    project: 1 as const,
  },

  pdfType: {
    portrait: "portrait",
    landscape: "landscape",
  },
  activityTypes: {
    proposal: 1,
    siteVisit: 2,
    reservation: 3,
  },
  leaseFeeType: {
    rent: 0 as const,
    scCharge: 1 as const,
    otherFee: 2 as const,
    discount: 3 as const,
  },
  roles: {
    admin: 3,
    dealer: 4,
  },
  sorterKey: {
    ascend: "asc",
    descend: "desc",
  },
  align: {
    right: "right" as const,
    left: "left" as const,
    center: "center" as const,
  },
  dataType: {
    string: "string" as const,
    number: "number" as const,
    boolean: "boolean" as const,
    method: "method" as const,
    regexp: "regexp" as const,
    integer: "integer" as const,
    float: "float" as const,
    object: "object" as const,
    enum: "enum" as const,
    date: "date" as const,
    url: "url" as const,
    hex: "hex" as const,
    email: "email" as const,
  },
  positionUser: {
    admin: 1 as const,
    dealer: 0 as const,
  },
  notifiType: {
    proposal: 9 as const,
    bookingForm: 17 as const,
    deposit: 18 as const,
    terminateNote: 19 as const,
    leaseAgreement: 20 as const,
  },
  unitReservationStatus: {
    new: 1 as const,
    close: 2 as const,
    cancel: 3 as const,
    expried: 4 as const,
    userCancel: 5 as const,
  },
  activityType: {
    call: 1 as const,
    mail: 2 as const,
    proposal: 3 as const,
    sitevisit: 4 as const,
    reservation: 5 as const,
  },

  paymentStatus: {
    unBill: 1 as const,
    paid: 2 as const,
    cancel: 3 as const,
  },
  billingStatus: [
    {
      id: 0,
      name: "unBilled",
      get label() {
        return L("UN_BILLED")
      },
    },
    {
      id: 1,
      name: "billed",
      get label() {
        return L("BILLED")
      },
    },
    {
      id: 2,
      name: "canceled",
      get label() {
        return L("CANCELED")
      },
    },
  ],
  listActivityType: [
    {
      id: 1,
      name: "call",
      get label() {
        return L("CALL")
      },
    },
    {
      id: 2,
      name: "mail",
      get label() {
        return L("MAIL")
      },
    },
    {
      id: 3,
      name: "proposal",
      get label() {
        return L("PROPOSAL")
      },
    },
    {
      id: 4,
      name: "sitevisit",
      get label() {
        return L("SITEVISIT")
      },
    },
    {
      id: 5,
      name: "reservation",
      get label() {
        return L("RESERVATION")
      },
    },
  ],
  inquiryStatusConst: {
    confirmed: 4 as const,
    dropped: 5 as const,
  },

  proposalType: {
    project: 1 as const,
    unit: 2 as const,
  },
  listProposalType: [
    {
      id: 1,
      name: "Project",
      get label() {
        return L("PROJECT")
      },
    },
    {
      id: 2,
      name: "Unit",
      get label() {
        return L("UNIT")
      },
    },
  ],
  contactType: [
    {
      id: 1,
      name: "individual",
      get label() {
        return L("INDIVIDUAL")
      },
    },
    {
      id: 2,
      name: "company",
      get label() {
        return L("COMPANY")
      },
    },
  ],
  listLaConfirmUnitStatus: [
    {
      id: 2,
      name: "Leased",
      get label() {
        return L("LEASED")
      },
    },
    {
      id: 5,
      name: "PmhUse",
      get label() {
        return L("PMH_USE")
      },
    },
    {
      id: 6,
      name: "InHouseUse",
      get label() {
        return L("IN_HOUSE_USE")
      },
    },
  ],
  inquirySource: [
    {
      id: 1,
      name: "newLead",
      get label() {
        return L("NEW_LEAD")
      },
    },
    {
      id: 2,
      name: "existTenant",
      get label() {
        return L("EXIST_TENANT")
      },
    },
    {
      id: 3,
      name: "oldProspect",
      get label() {
        return L("OLD_PROSPECT")
      },
    },
  ],
  expiredIn: [
    {
      id: 1,
      get label() {
        return L("0-30")
      },
    },
    {
      id: 2,
      get label() {
        return L("30-60")
      },
    },
    {
      id: 3,
      get label() {
        return L("60-90")
      },
    },
    {
      id: 4,
      get label() {
        return L(">90")
      },
    },
  ],
  leaseTerm: [
    {
      id: 1,
      name: "1year",
      get label() {
        return L("ONE_YEAR")
      },
    },
    {
      id: 2,
      name: "2year",
      get label() {
        return L("TWO_YEAR")
      },
    },
    {
      id: 3,
      name: "3year",
      get label() {
        return L("THREE_YEAR")
      },
    },
  ],
  paymentTerm: [
    {
      id: 1,
      name: "monthly",
      res: 12,
      countMonth: 1,
      get label() {
        return L("MONTHLY")
      },
    },
    {
      id: 2,
      res: 6,
      countMonth: 2,
      name: "biMonthly",
      get label() {
        return L("BI_MONTHLY")
      },
    },
    {
      id: 3,
      res: 4,
      countMonth: 3,
      name: "quaterly",
      get label() {
        return L("QUATERLY")
      },
    },
    {
      id: 4,
      res: 1,
      countMonth: 12,
      name: "yearly",
      get label() {
        return L("YEARLY")
      },
    },
    {
      id: 5,
      name: "oneTimePayment",
      res: 1,
      countMonth: 1,
      get label() {
        return L("ONE_TIME_PAYMENT")
      },
    },
  ],
  term: {
    monthly: 1 as const,
    biMonthly: 2 as const,
    quaterly: 3 as const,
    yearly: 4 as const,
    oneTimePayment: 5 as const,
  },
  depositLAStatus: {
    draf: 11 as const,
    send: 12 as const,
    paid: 13 as const,
    cancelled: 21 as const,
  },
  projectPermissionType: [
    {
      id: 1,
      name: "read",
      get label() {
        return L("READ_PERMISSION")
      },
    },
    {
      id: 2,
      name: "write",
      get label() {
        return L("READ_AND_WRITE_PERMISSION")
      },
    },
  ],

  amendmentLAItems: [
    {
      id: 1,
      name: "Commencement & expiry date",
      get label() {
        return L("Commencement & expiry date")
      },
    },
    {
      id: 2,
      name: "Rent",
      get label() {
        return L("Rent")
      },
    },
    {
      id: 3,
      name: "Other fees (Allowances)",
      get label() {
        return L("Other fees (Allowances)")
      },
    },
    {
      id: 4,
      name: "Discount",
      get label() {
        return L("Discount")
      },
    },
    {
      id: 5,
      name: "Unit",
      get label() {
        return L("Unit")
      },
    },
    {
      id: 6,
      name: "Payment term",
      get label() {
        return L("Payment term")
      },
    },

    {
      id: 8,
      name: "Payment date",
      get label() {
        return L("Payment date")
      },
    },
    {
      id: 9,
      name: "Exchange rate",
      get label() {
        return L("Exchange rate")
      },
    },
  ],
  amendmentItem: {
    commAndExpryDate: 1 as const,
    rent: 2 as const,
    otherFee: 3 as const,
    discount: 4 as const,
    unit: 5 as const,
    paymentTerm: 6 as const,
    checkInAndOutDate: 7 as const,
    paymentDate: 8 as const,
    exchangeRate: 9 as const,
  },

  formVerticalLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 24 },
      xl: { span: 24 },
      xxl: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 24 },
      xl: { span: 24 },
      xxl: { span: 24 },
    },
  },
  formVerticalLayout2: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 10 },
      lg: { span: 10 },
      xl: { span: 12 },
      xxl: { span: 12 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 14 },
      lg: { span: 14 },
      xl: { span: 12 },
      xxl: { span: 12 },
    },
  },
  formHorizontalLayout: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 8 },
      xl: { span: 8 },
      xxl: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 16 },
      xl: { span: 16 },
      xxl: { span: 16 },
    },
  },
  formHorizontalLayout24: {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 4 },
      xl: { span: 4 },
      xxl: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 24 },
      xl: { span: 24 },
      xxl: { span: 24 },
    },
  },
  formHorizontalLayout2: {
    labelCol: {
      xs: { span: 12 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 12 },
      xl: { span: 12 },
      xxl: { span: 12 },
    },
    wrapperCol: {
      xs: { span: 12 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 12 },
      xl: { span: 12 },
      xxl: { span: 12 },
    },
  },
  formHorizontalLayout242: {
    labelCol: {
      xs: { span: 12 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 10 },
      xl: { span: 10 },
      xxl: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 12 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 14 },
      xl: { span: 14 },
      xxl: { span: 24 },
    },
  },
  projectCategoryTarget: {
    unitType: "UNITTYPE",
    unitStatus: "UNITSTATUS",
    memberRole: "MEMBERROLE",
    memberType: "MEMBERTYPE",
  },
  ratingOptions: [
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },
    {
      value: 5,
    },
  ],
  escrowOptions: [100000, 200000, 500000, 800000],
  filterCommissionStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "yes",
      value: "true",
      get label() {
        return L("HAS_COMMISSION")
      },
    },
    {
      name: "no",
      value: "false",
      get label() {
        return L("NOT_HAS_COMMISSION")
      },
    },
  ],

  confirmedStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "Active",
      value: "true",
      get label() {
        return L("CONFIRMED")
      },
    },
    {
      name: "Inactive",
      value: "false",
      get label() {
        return L("UNCONFIRMED")
      },
    },
  ],
  activeStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "Active",
      value: "true",
      get label() {
        return L("ACTIVE")
      },
    },
    {
      name: "Inactive",
      value: "false",
      get label() {
        return L("DEACTIVATE")
      },
    },
  ],
  contractTerminatedStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "Active",
      value: "true",
      get label() {
        return L("CONTRACT_TERMINATED")
      },
    },
    {
      name: "Inactive",
      value: "false",
      get label() {
        return L("CONTRACT_ACTIVE")
      },
    },
  ],
  blockStatus: [
    {
      name: "BLOCKED",
      value: "true",
      get label() {
        return L("BLOCKED")
      },
    },
    {
      name: "UNBLOCKED",
      value: "false",
      get label() {
        return L("UNBLOCKED")
      },
    },
  ],

  viewDataStatus: [
    {
      name: "Active",
      value: "true",
      get label() {
        return L("VIEW_FULL")
      },
    },
    {
      name: "Inactive",
      value: "false",
      get label() {
        return L("NOT_VIEW_FULL")
      },
    },
  ],

  reportType: [
    {
      name: "Year To Date",
      value: "year",
      get label() {
        return L("YEAR_TO_DATE")
      },
    },
    {
      name: "Month To Date",
      value: "month",
      get label() {
        return L("MONTH_TO_DATE")
      },
    },
  ],

  requestStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("REQUEST_ALL")
      },
    },
    {
      name: "Active",
      value: "true",
      get label() {
        return L("REQUEST_ACTIVE")
      },
    },
    {
      name: "Inactive",
      value: "false",
      get label() {
        return L("REQUEST_WAITING")
      },
    },
  ],
  authenticationOptions: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "Active",
      value: "1",
      get label() {
        return L("AUTHENTICATED")
      },
    },
    {
      name: "Inactive",
      value: "0",
      get label() {
        return L("UNAUTHENTICATED")
      },
    },
  ],
  emailAuthenticationStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "Authentication",
      value: "true",
      get label() {
        return L("EMAIL_AUTHENTICATION")
      },
    },
    {
      name: "Unauthentication",
      value: "false",
      get label() {
        return L("EMAIL_UNAUTHENTICATION")
      },
    },
  ],
  phoneAuthenticationStatus: [
    {
      name: "All",
      value: " ",
      get label() {
        return L("ALL")
      },
    },
    {
      name: "Authentication",
      value: "true",
      get label() {
        return L("PHONE_AUTHENTICATION")
      },
    },
    {
      name: "Unauthentication",
      value: "false",
      get label() {
        return L("PHONE_UNAUTHENTICATION")
      },
    },
  ],
  genders: [
    { name: "GENDER_MALE", value: true },
    { name: "GENDER_FEMALE", value: false },
    { name: "GENDER_OTHER", value: undefined },
  ],
  bookingTimes: [
    {
      get name() {
        return L("DAY")
      },
      value: "DAY",
    },
    {
      get name() {
        return L("WEEK")
      },
      value: "WEEK",
    },
    {
      get name() {
        return L("MONTH")
      },
      value: "MONTH",
    },
  ],
  bookingFutureTypes: [
    {
      value: "CURRENT",
      get label() {
        return L("CURRENT")
      },
    },
    {
      value: "CURRENT_AND_NEXT",
      get label() {
        return L("CURRENT_AND_NEXT")
      },
    },
    {
      value: "NEXT",
      get label() {
        return L("NEXT")
      },
    },
  ],
  bookingDates: [
    {
      numNextValidDate: "ALL_DAY",
      value: "ALL_DAY",
      label: "ALL_DAY",
      isAnyTime: true,
      daySelected: true,
      order: 0,
    },
    {
      numNextValidDate: "MONDAY",
      value: "MONDAY",
      label: "MONDAY",
      isAnyTime: true,
      daySelected: true,
      order: 1,
    },
    {
      numNextValidDate: "TUESDAY",
      value: "TUESDAY",
      label: "TUESDAY",
      isAnyTime: true,
      daySelected: true,
      order: 2,
    },
    {
      numNextValidDate: "WEDNESDAY",
      value: "WEDNESDAY",
      label: "WEDNESDAY",
      isAnyTime: true,
      daySelected: true,
      order: 3,
    },
    {
      numNextValidDate: "THURSDAY",
      value: "THURSDAY",
      label: "THURSDAY",
      isAnyTime: true,
      daySelected: true,
      order: 4,
    },
    {
      numNextValidDate: "FRIDAY",
      value: "FRIDAY",
      label: "FRIDAY",
      isAnyTime: true,
      daySelected: true,
      order: 5,
    },
    {
      numNextValidDate: "SATURDAY",
      value: "SATURDAY",
      label: "SATURDAY",
      isAnyTime: true,
      daySelected: true,
      order: 6,
    },
    {
      numNextValidDate: "SUNDAY",
      value: "SUNDAY",
      label: "SUNDAY",
      isAnyTime: true,
      daySelected: true,
      order: 7,
    },
  ],
  reservationStatus: {
    requested: "REQUESTED",
    approved: "APPROVED",
  },
  userManagement: {
    defaultAdminUserName: "admin",
  },
  localization: localizationConst,
  authorization: {
    encrptedAuthTokenName: "enc_auth_token",
    projectId: "projectId",
    targetApplication: 1,
  },
  validate: {
    maxNumber: 999999999999,
  },
  masterDataTargets: {
    WORK_ORDER_TYPE: "WorkOrderType",
    UNIT_TYPE: "UnitType",
    UNIT_STATUS: "UnitStatus",
    RESIDENT_TYPE: "ResidentType",
    RESIDENT_ROLE: "ResidentRole",
  },
  notificationTypes: {
    all: 0,
    sms: 1,
    email: 2,
    inApp: 3,
  },
  announcementTypes: {
    picture: "Picture",
    video: "Video",
    updateApp: "UpdateApp",
  },
  announcementMethodTypes: {
    all: 0,
    email: 1,
    inApp: 2,
  },
  announcementMethodTypeKeys: {
    0: "ALL",
    1: "EMAIL", //(allow HTML)
    2: "INAPP",
  },
  announcementStatus: {
    readyForPublish: 1,
    sending: 2,
    completed: 3,
    failed: 4,
  },
  announcementStatusKeys: {
    0: "ANNOUNCEMENT_STATUS_PROCESSING",
    1: "ANNOUNCEMENT_STATUS_READY_FOR_PUBLISH",
    2: "ANNOUNCEMENT_STATUS_SENDING",
    3: "ANNOUNCEMENT_STATUS_COMPLETED",
    4: "ANNOUNCEMENT_STATUS_FAILED",
  },
  monthNamesShort: [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ],
  timeUnits: {
    hours: "HOURS",
    days: "DAYS",
    minutes: "MINUTES",
  },

  cashAdvanceTransactionTypes: {
    receipt: 1,
    expenseMandate: 2,
  },
  pickerType: {
    month: "month",
    quarter: "quarter",
    year: "year",
  },
  datePickerType: [
    {
      get name() {
        return L("MONTH")
      },
      value: "month",
    },
    {
      get name() {
        return L("QUATER")
      },
      value: "quarter",
    },

    {
      get name() {
        return L("YEAR")
      },
      value: "year",
    },
  ],
  dayOfWeek: [
    {
      value: 0,
      name: "Sunday",
    },
    {
      value: 1,
      name: "Monday",
    },
    {
      value: 2,
      name: "Tuesday",
    },
    {
      value: 3,
      name: "Wednesday",
    },
    {
      value: 4,
      name: "Thursday",
    },
    {
      value: 5,
      name: "Friday",
    },
    {
      value: 6,
      name: "Saturday",
    },
  ],
}

export const AppStatus = {
  withdrawStatus: {
    cancelled: "CANCELLED",
    processed: "PROCESSED",
    isDone: (statusCode) =>
      statusCode === "CANCELLED" || statusCode === "PROCESSED",
  },
  activeStatus: {},
  announcementStatus: {
    cancelled: "CANCELLED",
    processed: "PROCESSED",
    isDone: (statusCode) =>
      statusCode === "CANCELLED" || statusCode === "PROCESSED",
  },
}
export const userType = {
  staff: "1",
  tenant: "2",
}

export const ouType = {
  AGENCY: "AGENCY", //nhân viên sàn
  STAFF: "STAFF", //nhân viên chủ đầu tư
  CLIENT: "CLIENT", //customer
}

export const loginSteps = {
  login: 1,
  projectSelect: 2,
}
export const loginMethods = {
  systemAccount: 1,
  socialAccount: 2,
  phoneNumber: 3,
}

export const workflowEvent = {
  init: "InitWorkflow",
}
export const documentTypes = {
  image: "IMAGE",
  document: "DOCUMENT",
}
export const cookieKeys = {
  encToken: "enc_auth_token",
}

export function dateDifference(startDate, endDate) {
  const years = endDate.diff(startDate, "years")
  startDate.add(years, "years")

  const months = endDate.diff(startDate, "months")
  startDate.add(months, "months")

  const days = endDate.diff(startDate, "days")

  return {
    years: years,
    months: months,
    days: days,
  }
}
export const keySyncfusion =
  "Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXdcdnRQQ2RZUU11W0FWYE0="

export const defaultAvatar = "/assets/images/logoCore.png"
export const dateFormat = "DD/MM/YYYY"
export const weekFormat = "[W]ww/YYYY"
export const dateSortFormat = "YYYYMMDD"
export const dateTimeFormat = "DD/MM/YYYY HH:mm"
export const yearFormat = "YYYY"
export const monthFormat = "MM/YYYY"
export const monthCharFormat = "YYYY MMM"
export const timeFormat = "HH:mm"
export const phoneRegex =
  /^$|^(?=(?:[^0-9]*[0-9]){7,})[0-9][+]?\(?([0-9]{0,3})?\)?[-.]?([0-9]{1,3})?[-.]?([0-9]{1,3})[-.]?([0-9]{1,5})$/

export const emailRegex =
  /^(?:[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})?$/

export const websiteRegex =
  /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,4}(\/[\w-]*)*\/?$/

export const modules = [
  {
    get name() {
      return LCategory("MODULE_WORKORDER")
    },
    id: 13,
  },
  {
    get name() {
      return LCategory("MODULE_FEEDBACK")
    },
    id: 20,
  },
]
export const moduleIds = {
  dismantlingRequest: 14,
  workOrder: 13,
  feedback: 20,
  unit: 1,
  unitEdit: 1001,
  comment: 1002,
  reservation: 17,
  visitor: 1003,
  planMaintenance: 18,
  inventory: 34,
  order: 47,
  inspection: 41,
  cogs: 47,
  ratingBadge: 301,
  feedbackType: 201,
  feedbackCategory: 201,
  opMargin: 47,
  transportationCost: 47,
  quotationProject: 47,
  shareContact: 103,
  company: 7,
  requirement: 26,
  contact: 8,
  opportunity: 9,
  project: 25,
  dealContract: 33,
  activity: 26,
  accountant: 43,
  cartEmail: 119,
  cartSms: 120,
}
export const moduleNames = {
  unit: "UNIT",
  news: "NEWS",
  requirement: "REQUEST",
  company: "COMPANY",
  inquiry: "INQUIRY",
  contact: "CONTACT",
  contract: "CONTRACT",
  opportunity: "OPPORTUNITY",
  project: "PROJECT",
  logoProject: "LOGO_PROJECT",
  dealContract: "DEAL",
  listing: "LISTING",
  mail: "MAIL",
  tenant: "TENANT",
  // CRM
  customer: "CUSTOMER",
  customerAvatar: "CUSTOMERAVATAR",
  booking: "BOOKING",
  TRADINGFLOOR: "TRADINGFLOOR",
  PROFILE: "PROFILE",
}
export const modulePrefix = {
  13: "WORK_ORDER_WF_",
  20: "FEEDBACK_WF_",
  14: "DISMANTLING_REQUEST_",
}

export const sidebarStatus = {
  menu: 1,
  setting: 2,
  account: 3,
}

export const budgetAppType = {
  unit: 1,
  revenue: 2,
}
export const moduleFile = {
  library: "Library",
  project: "Project",
  workOrder: "WorkOrder",
  feedback: "Feedback",
  news: "News",
  event: "Event",
  reservation: "Reservation",
  chatMessage: "ChatMessages",
  amenity: "Amenities",
  visitor: "Visitor",
  company: "Company",
  contract: "Contract",
  contractCategory: "ContractCategory",
  buildingDirectory: "BuildingDirectory",
  planMaintenance: "PlanMaintenance",
  asset: "AssetManagement",
  shopOwner: "ShopOwner",
  product: "Product",
  inventory: "Inventory",
  inventoryStockIn: "InventoryStock",
  inventoryStockOut: "InventoryAllocate",
  // masterData
  projectFacility: "ProjectFacility",
  unitFacility: "UnitFacility",
  unitType: "UnitType",
  unitDesign: "UnitDesign",
  customerSource: "CustomerSource",
  customerAvatar: "CustomerAvatar",
}
export const notificationMethod = {
  1: "SMS",
  2: "EMAIL", //(allow HTML)
  3: "INAPP",
}
export const notificationMethods = [
  {
    get name() {
      return LCategory("SMS")
    },
    id: 1,
  },
  {
    get name() {
      return LCategory("EMAIL")
    },
    id: 2,
  },
  {
    get name() {
      return LCategory("INAPP")
    },
    id: 3,
  },
]
export const userGroups = [
  {
    get name() {
      return LCategory("STAFF")
    },
    id: 1,
  },
  {
    get name() {
      return LCategory("CUSTOMER")
    },
    id: 2,
  },
  {
    get name() {
      return LCategory("PARTNER")
    },
    id: 3,
  },
]

export const phoneStatus = {
  undefined: 0,
  available: 1,
  inActive: 2,
  notFound: 3,
}

export const getEscalationModuleByModuleId = (moduleId) => {
  switch (moduleId) {
    case moduleIds.inspection: {
      return 4
    }
    case moduleIds.planMaintenance: {
      return 3
    }
    case moduleIds.feedback: {
      return 2
    }
    case moduleIds.workOrder:
    default: {
      return 1
    }
  }
}
export const appStatusColors = {
  success: "#689F38",
  error: "#EB7077",
  valid: "#689F38",
  expired: "#CCCCCC",
}
export const backgroundColors = [
  "#FAC51D",
  "#66BD6D",
  "#FAA026",
  "#29BB9C",
  "#E96B56",
  "#55ACD2",
  "#B7332F",
  "#2C83C9",
  "#9166B8",
  "#92E7E8",
]
export const getBackgroundColorByIndex = (arrayIndex) => {
  const index = arrayIndex % backgroundColors.length
  return backgroundColors[index]
}

export const moduleAvatar = {
  myProfile: "myProfile",
  staff: "Staff",
  resident: "Resident",
  shopOwner: "ShopOwner",
  project: "Project",
  colorByLetter: (letter) => {
    if (!backgroundColors || !letter) return "#fff"

    const charCode = letter.charCodeAt(0)
    return getBackgroundColorByIndex(charCode)
  },
}
export const wfFieldTypes = {
  text: 0,
  number: 1,
  money: 2,
  dateTime: 3,
  list: 4,
}

export const ckeditorToolbar = {
  toolbarGroups: [
    { name: "document", groups: ["mode", "doctools", "document", "source"] },
    { name: "clipboard", groups: ["clipboard", "undo"] },
    {
      name: "editing",
      groups: ["find", "selection", "spellchecker", "editing"],
    },
    { name: "styles", groups: ["styles", "font-family"] },
    { name: "forms", groups: ["forms"] },
    { name: "colors", groups: ["colors"] },
    { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
    {
      name: "paragraph",
      groups: ["align", "list", "indent", "blocks", "bidi", "paragraph"],
    },
    { name: "links", groups: ["links"] },
    { name: "insert", groups: ["insert"] },
    { name: "tools", groups: ["tools"] },
    { name: "others", groups: ["others"] },
    { name: "about", groups: ["about"] },
  ],
  removeButtons:
    "Save,Templates,Cut,NewPage,Preview,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,ShowBlocks,About,Flash,PageBreak,HorizontalRule,Language,BidiRtl,BidiLtr,Blockquote,CreateDiv,Smiley,Iframe",
}
export const mimeType = {
  "application/pdf": PdfIcon,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    ExcelIcon,
  "application/vnd.ms-excel": ExcelIcon,
  "application/msword": WordIcon,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    WordIcon,
  "application/vnd.ms-powerpoint": PowerPointIcon,
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    PowerPointIcon,
  "application/vnd.ms-outlook": MsgIcon,
  "image/jpeg": ImageIcon,
  "image/png": ImageIcon,
  other: OtherFileIcon,
}
export const mimeTypeToImagePath = {
  "application/pdf": "/assets/icons/pdf.svg",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    "/assets/icons/excel.svg",
  "application/vnd.ms-excel": "/assets/icons/excel.svg",
  "application/msword": "/assets/icons/word.svg",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "/assets/icons/word.svg",
  "application/vnd.ms-powerpoint": "/assets/icons/power-point.svg",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "/assets/icons/power-point.svg",
  "application/vnd.ms-outlook": "/assets/icons/email-msg.svg",
  "image/jpeg": "/assets/icons/image-file.svg",
  "image/png": "/assets/icons/image-file.svg",
  other: "/assets/icons/other-file.svg",
}
export const appPermissions = {
  activity: {
    createUpdate: "PagesAdministration.Activity.CreateOrUpdate",
    delete: "PagesAdministration.Activity.Delete",
    detail: "PagesAdministration.Activity.Detail",
    page: "PagesAdministration.Activity",
    read: "PagesAdministration.Activity.Read",
  },
  agencyMaster: {
    create: "PagesAdministration.AgencyMaster.Create",
    delete: "PagesAdministration.AgencyMaster.Delete",
    detail: "PagesAdministration.AgencyMaster.Detail",
    page: "PagesAdministration.AgencyMaster",
    read: "PagesAdministration.AgencyMaster.Read",
    update: "PagesAdministration.AgencyMaster.Update",
    // Tab "Tổng quan 360" trên màn chi tiết đại lý / sàn giao dịch (Feature-0193)
    viewAgency360: "PagesAdministration.AgencyMaster.ViewAgency360",
  },
  booking: {
    cancel: "PagesAdministration.Booking.Cancel",
    create: "PagesAdministration.Booking.Create",
    delete: "PagesAdministration.Booking.Delete",
    detail: "PagesAdministration.Booking.Detail",
    export: "PagesAdministration.Booking.Export",
    page: "PagesAdministration.Booking",
    powerUser: "PagesAdministration.Booking.PowerUser",
    read: "PagesAdministration.Booking.Read",
    stackingPlan: "PagesAdministration.Booking.StackingPlan",
    update: "PagesAdministration.Booking.Update",
    changeUnit: "PagesAdministration.Booking.ChangeUnit",
    viewFull: "PagesAdministration.Booking.ViewAll",
    import: "PagesAdministration.Booking.Import",
  },
  // ⚠️ FE-BE MISMATCH: "PagesAdministration.PaymentSchedule.*" is NOT defined in
  // BE AppPermissions.cs, so every isGranted() below always returns false and
  // the feature stays hidden. BE must add the PaymentSchedule permission group
  // before these become effective.
  paymentSchedule: {
    page: "PagesAdministration.PaymentSchedule",
    read: "PagesAdministration.PaymentSchedule.Read",
    createUpdate: "PagesAdministration.PaymentSchedule.CreateAndUpdate",
    delete: "PagesAdministration.PaymentSchedule.Delete",
    detail: "PagesAdministration.PaymentSchedule.Detail",
  },

  bookingReceipt: {
    page: "PagesAdministration.BookingReceipt",
    read: "PagesAdministration.BookingReceipt.Read",
    detail: "PagesAdministration.BookingReceipt.Detail",
  },
  bookingReservation: {
    createUpdate: "PagesAdministration.BookingReservation.CreateOrUpdate",
    delete: "PagesAdministration.BookingReservation.Delete",
    detail: "PagesAdministration.BookingReservation.Detail",
    page: "PagesAdministration.BookingReservation",
    read: "PagesAdministration.BookingReservation.Read",
    sendRequest: "PagesAdministration.BookingReservation.SendRequest",
    refund: "PagesAdministration.BookingReservation.Refund",
    offset: "PagesAdministration.BookingReservation.Offset",
    viewContractInquiry: "PagesAdministration.BookingReservation.ViewContractInquiry",
  },
  cart: {
    create: "PagesAdministration.Cart.Create",
    delete: "PagesAdministration.Cart.Delete",
    detail: "PagesAdministration.Cart.Detail",
    export: "PagesAdministration.Cart.Export",
    page: "PagesAdministration.Cart",
    read: "PagesAdministration.Cart.Read",
    update: "PagesAdministration.Cart.Update",
    viewFull: "PagesAdministration.Cart.ViewAll",
  },
  notificationAuditLog: {
    page: "PagesAdministration.NotificationAuditLog",
    read: "PagesAdministration.NotificationAuditLog.Read",
    export: "PagesAdministration.NotificationAuditLog.Export",
  },
  contact: {
    associate: "PagesAdministration.Contact.Associate",
    create: "PagesAdministration.Contact.Create",
    delete: "PagesAdministration.Contact.Delete",
    detail: "PagesAdministration.Contact.Detail",
    export: "PagesAdministration.Contact.Export",
    page: "PagesAdministration.Contact",
    read: "PagesAdministration.Contact.Read",
    update: "PagesAdministration.Contact.Update",
  },
  contract: {
    associate: "PagesAdministration.Contract.Associate",
    cancel: "PagesAdministration.Contract.Cancel",
    create: "PagesAdministration.Contract.Create",
    delete: "PagesAdministration.Contract.Delete",
    detail: "PagesAdministration.Contract.Detail",
    export: "PagesAdministration.Contract.Export",
    page: "PagesAdministration.Contract",
    read: "PagesAdministration.Contract.Read",
    update: "PagesAdministration.Contract.Update",
    import: "PagesAdministration.Contract.Import",
    approval: "PagesAdministration.Contract.UpdateAfterApproved",
    // Sửa phần "Khách hàng" trên hợp đồng. Tách khỏi contract.update và khỏi quyền duyệt:
    // BE kiểm riêng quyền này (ContractAppService.UpdateAsync).
    updateCustomerInfo: "PagesAdministration.Contract.UpdateCustomerInfo",
    paymentTermRead: "PagesAdministration.Contract.PaymentTermRead",
    paymentTermExport: "PagesAdministration.Contract.PaymentTermExport",
    // Tab "Tổng quan 360" trên màn chi tiết hợp đồng (Feature-0193)
    viewContract360: "PagesAdministration.Contract.ViewContract360",
    // Tab "Cấu hình lãi" trên màn chi tiết hợp đồng
    interestSettingRead: "PagesAdministration.Contract.InterestSetting",
    interestSettingUpdate: "PagesAdministration.Contract.InterestSettingUpdate",
  },

  customFilter: {
    create: "PagesAdministration.CustomFilter.Create",
    delete: "PagesAdministration.CustomFilter.Delete",
    detail: "PagesAdministration.CustomFilter.Detail",
    page: "PagesAdministration.CustomFilter",
    read: "PagesAdministration.CustomFilter.Read",
    update: "PagesAdministration.CustomFilter.Update",
  },
  customer: {
    create: "PagesAdministration.Customer.Create",
    delete: "PagesAdministration.Customer.Delete",
    detail: "PagesAdministration.Customer.Detail",
    export: "PagesAdministration.Customer.Export",
    page: "PagesAdministration.Customer",
    read: "PagesAdministration.Customer.Read",
    update: "PagesAdministration.Customer.Update",
    viewFull: "PagesAdministration.Customer.ViewFull",
  },
  existingCustomer: {
    page: "PagesAdministration.ExistingCustomer",
    read: "PagesAdministration.ExistingCustomer.Read",
    create: "PagesAdministration.ExistingCustomer.Create",
    delete: "PagesAdministration.ExistingCustomer.Delete",
    detail: "PagesAdministration.ExistingCustomer.Detail",
    export: "PagesAdministration.ExistingCustomer.Export",
    import: "PagesAdministration.ExistingCustomer.Import",
    update: "PagesAdministration.ExistingCustomer.Update",
    // Feature-0381 — cập nhật KHHH có hiệu lực ngay, không sinh phiếu duyệt.
    updateWithoutApproval:
      "PagesAdministration.ExistingCustomer.UpdateWithoutApproval",
    viewFull: "PagesAdministration.ExistingCustomer.ViewFull",
    activity: "PagesAdministration.ExistingCustomer.Activity",
    // Tab "Tổng quan 360" trên màn chi tiết KH hiện hữu (Feature-0193)
    viewCustomer360: "PagesAdministration.ExistingCustomer.ViewCustomer360",
  },
  dashboard: {
    feeStatement: "PagesAdministration.Dashboard.FeeStatement",
    headerMetrics: "PagesAdministration.Dashboard.HeaderMetrics",
    overview: "PagesAdministration.Dashboard.Overview",
    page: "PagesAdministration.Dashboard",
    report: "PagesAdministration.Dashboard.Report",
    workOrder: "PagesAdministration.Dashboard.WorkOrder",
    summary: "PagesAdministration.Dashboard.Summary",
    agencyMaster: "PagesAdministration.Dashboard.AgencyMaster",
    unitStatus: "PagesAdministration.Dashboard.UnitStatus",
    customer: "PagesAdministration.Dashboard.Customer",
    // Dashboard Suite (Feature-0196). feeStatement/workOrder phía trên đã deprecate ở backend
    // (chưa từng đăng ký) nên isGranted trên chúng luôn false — dùng csFee thay cho feeStatement.
    cs: "PagesAdministration.Dashboard.Cs",
    csMyTasks: "PagesAdministration.Dashboard.Cs.MyTasks",
    csFee: "PagesAdministration.Dashboard.Cs.Fee",
    csPinkBookHandover: "PagesAdministration.Dashboard.Cs.PinkBookHandover",
    csFeedback: "PagesAdministration.Dashboard.Cs.Feedback",
    csCustomer: "PagesAdministration.Dashboard.Cs.Customer",
    csTeam: "PagesAdministration.Dashboard.Cs.Team",
    finance: "PagesAdministration.Dashboard.Finance",
    sales: "PagesAdministration.Dashboard.Sales",
    salesOps: "PagesAdministration.Dashboard.Sales.Ops",
    salesBusiness: "PagesAdministration.Dashboard.Sales.Business",
    executive: "PagesAdministration.Dashboard.Executive"
  },
  feedback: {
    approval: "PagesAdministration.Feedback.Approval",
    create: "PagesAdministration.Feedback.Create",
    delete: "PagesAdministration.Feedback.Delete",
    detail: "PagesAdministration.Feedback.Detail",
    export: "PagesAdministration.Feedback.Export",
    myFeedback: "PagesAdministration.Feedback.MyFeedback",
    page: "PagesAdministration.Feedback",
    read: "PagesAdministration.Feedback.Read",
    update: "PagesAdministration.Feedback.Update",
  },
  handoverPlan: {
    create: "PagesAdministration.HandoverPlan.Create",
    delete: "PagesAdministration.HandoverPlan.Delete",
    detail: "PagesAdministration.HandoverPlan.Detail",
    page: "PagesAdministration.HandoverPlan",
    read: "PagesAdministration.HandoverPlan.Read",
    update: "PagesAdministration.HandoverPlan.Update",
    export: "PagesAdministration.HandoverPlan.Export",
    import: "PagesAdministration.HandoverPlan.Import",
  },
  handoverReservation: {
    page: "PagesAdministration.HandoverReservation",
    create: "PagesAdministration.HandoverReservation.Create",
    update: "PagesAdministration.HandoverReservation.Update",
    read: "PagesAdministration.HandoverReservation.Read",
    delete: "PagesAdministration.HandoverReservation.Delete",
    detail: "PagesAdministration.HandoverReservation.Detail",
    export: "PagesAdministration.HandoverReservation.Export",
    print: "PagesAdministration.HandoverReservation.Print",
  },
  inquiry: {
    page: "PagesAdministration.Inquiry",
    create: "PagesAdministration.Inquiry.Create",
    read: "PagesAdministration.Inquiry.Read",
    update: "PagesAdministration.Inquiry.Update",
    delete: "PagesAdministration.Inquiry.Delete",
    detail: "PagesAdministration.Inquiry.Detail",
  },
  languages: {
    create: "PagesAdministration.Languages.Create",
    delete: "PagesAdministration.Languages.Delete",
    detail: "PagesAdministration.Languages.Detail",
    page: "PagesAdministration.Languages",
    read: "PagesAdministration.Languages.Read",
    update: "PagesAdministration.Languages.Update",
  },
  masterData: {
    page: "PagesAdministration.MasterData",
    company: {
      createUpdate: "PagesAdministration.MasterData.Company.CreateAndUpdate",
      read: "PagesAdministration.MasterData.Company.Read",
      delete: "PagesAdministration.MasterData.Company.Delete",
      detail: "PagesAdministration.MasterData.Company.Detail",
      export: "PagesAdministration.MasterData.Company.Export",
      import: "PagesAdministration.MasterData.Company.Import",
    },

    offsetAccount: {
      createUpdate:
        "PagesAdministration.MasterData.OffsetAccount.CreateAndUpdate",
      read: "PagesAdministration.MasterData.OffsetAccount.Read",
      delete: "PagesAdministration.MasterData.OffsetAccount.Delete",
      detail: "PagesAdministration.MasterData.OffsetAccount.Detail",
      export: "PagesAdministration.MasterData.OffsetAccount.Export",
      import: "PagesAdministration.MasterData.OffsetAccount.Import",
    },
    group: {
      createUpdate: "PagesAdministration.MasterData.Group.CreateAndUpdate",
      read: "PagesAdministration.MasterData.Group.Read",
      detail: "PagesAdministration.MasterData.Group.Detail",
      remove: "PagesAdministration.MasterData.Group.Remove",
      assign: "PagesAdministration.MasterData.Group.Assign",
    },
    costCenter: {
      createUpdate: "PagesAdministration.MasterData.CostCenter.CreateAndUpdate",
      read: "PagesAdministration.MasterData.CostCenter.Read",
      delete: "PagesAdministration.MasterData.CostCenter.Delete",
      detail: "PagesAdministration.MasterData.CostCenter.Detail",
      export: "PagesAdministration.MasterData.CostCenter.Export",
      import: "PagesAdministration.MasterData.CostCenter.Import",
    },
    customerSource: {
      createUpdate:
        "PagesAdministration.MasterData.CustomerSourcing.CreateAndUpdate",
      read: "PagesAdministration.MasterData.CustomerSourcing.Read",
      delete: "PagesAdministration.MasterData.CustomerSourcing.Delete",
      detail: "PagesAdministration.MasterData.CustomerSourcing.Detail",
    },
    projectFacility: {
      createUpdate:
        "PagesAdministration.MasterData.ProjectFacility.CreateAndUpdate",
      read: "PagesAdministration.MasterData.ProjectFacility.Read",
      delete: "PagesAdministration.MasterData.ProjectFacility.Delete",
      detail: "PagesAdministration.MasterData.ProjectFacility.Detail",
    },
    township: {
      createUpdate: "PagesAdministration.MasterData.Township.CreateAndUpdate",
      read: "PagesAdministration.MasterData.Township.Read",
      delete: "PagesAdministration.MasterData.Township.Delete",
      detail: "PagesAdministration.MasterData.Township.Detail",
    },
    tower: {
      createUpdate: "PagesAdministration.MasterData.Tower.CreateAndUpdate",
      read: "PagesAdministration.MasterData.Tower.Read",
      delete: "PagesAdministration.MasterData.Tower.Delete",
      detail: "PagesAdministration.MasterData.Tower.Detail",
      import: "PagesAdministration.MasterData.Tower.Import",
      export: "PagesAdministration.MasterData.Tower.Export",
    },
    unitDesign: {
      createUpdate: "PagesAdministration.MasterData.UnitDesign.CreateAndUpdate",
      read: "PagesAdministration.MasterData.UnitDesign.Read",
      delete: "PagesAdministration.MasterData.UnitDesign.Delete",
      detail: "PagesAdministration.MasterData.UnitDesign.Detail",
    },
    unitFacility: {
      createUpdate:
        "PagesAdministration.MasterData.UnitFacility.CreateAndUpdate",
      read: "PagesAdministration.MasterData.UnitFacility.Read",
      delete: "PagesAdministration.MasterData.UnitFacility.Delete",
      detail: "PagesAdministration.MasterData.UnitFacility.Detail",
    },
    unitType: {
      createUpdate: "PagesAdministration.MasterData.UnitType.CreateAndUpdate",
      read: "PagesAdministration.MasterData.UnitType.Read",
      delete: "PagesAdministration.MasterData.UnitType.Delete",
      detail: "PagesAdministration.MasterData.UnitType.Detail",
    },
    propertyType: {
      createUpdate:
        "PagesAdministration.MasterData.PropertyType.CreateAndUpdate",
      read: "PagesAdministration.MasterData.PropertyType.Read",
      detail: "PagesAdministration.MasterData.PropertyType.Detail",
    },
    project: {
      create: "PagesAdministration.MasterData.Project.Create",
      read: "PagesAdministration.MasterData.Project.Read",
      update: "PagesAdministration.MasterData.Project.Update",
      delete: "PagesAdministration.MasterData.Project.Delete",
      detail: "PagesAdministration.MasterData.Project.Detail",
      stackingPlan: "PagesAdministration.MasterData.Project.StackingPlan",
      import: "PagesAdministration.MasterData.Project.Import",
      userPermission: "PagesAdministration.MasterData.Project.UserPermission",
      // Tab "Tổng quan 360" trên màn chi tiết dự án (Feature-0193)
      viewProject360: "PagesAdministration.MasterData.Project.ViewProject360",
    },

    floor: {
      createUpdate: "PagesAdministration.MasterData.Floor.CreateAndUpdate",
      read: "PagesAdministration.MasterData.Floor.Read",
      delete: "PagesAdministration.MasterData.Floor.Delete",
      detail: "PagesAdministration.MasterData.Floor.Detail",
      import: "PagesAdministration.MasterData.Floor.Import",
      export: "PagesAdministration.MasterData.Floor.Export",
    },
    ProjectAccount: {
      createUpdate:
        "PagesAdministration.MasterData.ProjectAccount.CreateAndUpdate",
      read: "PagesAdministration.MasterData.ProjectAccount.Read",
      detail: "PagesAdministration.MasterData.ProjectAccount.Detail",
    },
    unitMasterData: {
      create: "PagesAdministration.MasterData.UnitMasterData.Create",
      read: "PagesAdministration.MasterData.UnitMasterData.Read",
      update: "PagesAdministration.MasterData.UnitMasterData.Update",
      delete: "PagesAdministration.MasterData.UnitMasterData.Delete",
      detail: "PagesAdministration.MasterData.UnitMasterData.Detail",
      import: "PagesAdministration.MasterData.UnitMasterData.Import",
      viewUnit360: "PagesAdministration.MasterData.UnitMasterData.ViewUnit360",
    },
    phaseCode: {
      createUpdate: "PagesAdministration.MasterData.PhaseCode.CreateAndUpdate",
      read: "PagesAdministration.MasterData.PhaseCode.Read",
      delete: "PagesAdministration.MasterData.PhaseCode.Delete",
      detail: "PagesAdministration.MasterData.PhaseCode.Detail",
    },
    holiday: {
      createUpdate: "PagesAdministration.MasterData.HolidayAndLeave.CreateAndUpdate",
      read: "PagesAdministration.MasterData.HolidayAndLeave.Read",
      delete: "PagesAdministration.MasterData.HolidayAndLeave.Delete",
      detail: "PagesAdministration.MasterData.HolidayAndLeave.Detail",
    }
  },
  misc: {
    page: "PagesAdministration",
  },

  pinkBook: {
    create: "PagesAdministration.PinkBook.Create",
    delete: "PagesAdministration.PinkBook.Delete",
    detail: "PagesAdministration.PinkBook.Detail",
    page: "PagesAdministration.PinkBook",
    read: "PagesAdministration.PinkBook.Read",
    update: "PagesAdministration.PinkBook.Update",
  },
  pricingApproval: {
    cancel: "PagesAdministration.PricingApproval.Cancel",
    createUpdate: "PagesAdministration.PricingApproval.CreateOrUpdate",
    delete: "PagesAdministration.PricingApproval.Delete",
    detail: "PagesAdministration.PricingApproval.Detail",
    page: "PagesAdministration.PricingApproval",
    read: "PagesAdministration.PricingApproval.Read",
    import: "PagesAdministration.PricingApproval.Import",
  },
  roles: {
    create: "PagesAdministration.Roles.Create",
    delete: "PagesAdministration.Roles.Delete",
    detail: "PagesAdministration.Roles.Detail",
    page: "PagesAdministration.Roles",
    read: "PagesAdministration.Roles.Read",
    update: "PagesAdministration.Roles.Update",
  },
  salesEvent: {
    create: "PagesAdministration.SalesEvent.Create",
    delete: "PagesAdministration.SalesEvent.Delete",
    detail: "PagesAdministration.SalesEvent.Detail",
    page: "PagesAdministration.SalesEvent",
    read: "PagesAdministration.SalesEvent.Read",
    update: "PagesAdministration.SalesEvent.Update",
    export: "PagesAdministration.SalesEvent.Export",
    sendNotification: "PagesAdministration.SalesEvent.SendNotification",
    cancel: "PagesAdministration.SalesEvent.Cancel",
    pickUnit: "PagesAdministration.SalesEvent.PickUnit",
    print: "PagesAdministration.SalesEvent.Print",
    representationCustomer:
      "PagesAdministration.SalesEvent.RepresentationCustomer",
    clearUnit: "PagesAdministration.SalesEvent.ClearUnit",
    retryPickUnit: "PagesAdministration.SalesEvent.RetryPickUnit",
  },
  salesPolicy: {
    cancel: "PagesAdministration.SalesPolicy.Cancel",
    create: "PagesAdministration.SalesPolicy.Create",
    delete: "PagesAdministration.SalesPolicy.Delete",
    detail: "PagesAdministration.SalesPolicy.Detail",
    page: "PagesAdministration.SalesPolicy",
    read: "PagesAdministration.SalesPolicy.Read",
    update: "PagesAdministration.SalesPolicy.Update",
  },
  setting: {
    create: "PagesAdministration.Setting.Create",
    delete: "PagesAdministration.Setting.Delete",
    detail: "PagesAdministration.Setting.Detail",
    page: "PagesAdministration.Setting",
    read: "PagesAdministration.Setting.Read",
    update: "PagesAdministration.Setting.Update",
  },
  staff: {
    create: "PagesAdministration.Staff.Create",
    delete: "PagesAdministration.Staff.Delete",
    detail: "PagesAdministration.Staff.Detail",
    page: "PagesAdministration.Staff",
    read: "PagesAdministration.Staff.Read",
    update: "PagesAdministration.Staff.Update",
    batchResetPassword: "PagesAdministration.Staff.BatchResetPassword",
    import: "PagesAdministration.Staff.Import",
  },
  system: {
    page: "PagesAdministration.System",
  },
  teams: {
    create: "PagesAdministration.Teams.Create",
    delete: "PagesAdministration.Teams.Delete",
    detail: "PagesAdministration.Teams.Detail",
    page: "PagesAdministration.Teams",
    read: "PagesAdministration.Teams.Read",
    update: "PagesAdministration.Teams.Update",
  },
  userGuide: {
    read: "PagesAdministration.UserGuide.Read",
    create: "PagesAdministration.UserGuide.Create",
    update: "PagesAdministration.UserGuide.Update",
    delete: "PagesAdministration.UserGuide.Delete",
    publish: "PagesAdministration.UserGuide.Publish",
  },
  // Download Request Center. `cancel` gánh cả Hủy lẫn Chạy lại (đổi vòng đời của một yêu cầu đã tạo);
  // `viewAll` mở tab quản trị xem yêu cầu của mọi người và KHÔNG được seed đại trà.
  downloadRequest: {
    page: "PagesAdministration.DownloadRequest",
    create: "PagesAdministration.DownloadRequest.Create",
    read: "PagesAdministration.DownloadRequest.Read",
    cancel: "PagesAdministration.DownloadRequest.Cancel",
    delete: "PagesAdministration.DownloadRequest.Delete",
    download: "PagesAdministration.DownloadRequest.Download",
    viewAll: "PagesAdministration.DownloadRequest.ViewAll",
  },
  userTenant: {
    create: "PagesAdministration.UserTenant.Create",
    delete: "PagesAdministration.UserTenant.Delete",
    detail: "PagesAdministration.UserTenant.Detail",
    page: "PagesAdministration.UserTenant",
    read: "PagesAdministration.UserTenant.Read",
    update: "PagesAdministration.UserTenant.Update",
  },
  feeType: {
    createUpdate: "PagesAdministration.MasterData.FeeType.CreateAndUpdate",
    read: "PagesAdministration.MasterData.FeeType.Read",
    delete: "PagesAdministration.MasterData.FeeType.Delete",
    detail: "PagesAdministration.MasterData.FeeType.Detail",
  },

  receiptType: {
    page: "PagesAdministration.InquiryFeeTypeSetting",
    read: "PagesAdministration.InquiryFeeTypeSetting.Read",
    create: "PagesAdministration.InquiryFeeTypeSetting.Create",
    update: "PagesAdministration.InquiryFeeTypeSetting.Update",
    delete: "PagesAdministration.InquiryFeeTypeSetting.Delete",
  },

  promotionProgram: {
    page: "PagesAdministration.PromotionProgram",
    create: "PagesAdministration.PromotionProgram.Create",
    read: "PagesAdministration.PromotionProgram.Read",
    update: "PagesAdministration.PromotionProgram.Update",
    delete: "PagesAdministration.PromotionProgram.Delete",
    detail: "PagesAdministration.PromotionProgram.Detail",
    import: "PagesAdministration.PromotionProgram.Import",
  },

  specialPromotionProgram: {
    page: "PagesAdministration.SpecialPromotionProgram",
    create: "PagesAdministration.SpecialPromotionProgram.Create",
    read: "PagesAdministration.SpecialPromotionProgram.Read",
    update: "PagesAdministration.SpecialPromotionProgram.Update",
    delete: "PagesAdministration.SpecialPromotionProgram.Delete",
    detail: "PagesAdministration.SpecialPromotionProgram.Detail",
  },
  workflow: {
    page: "PagesAdministration.Workflow",
    create: "PagesAdministration.Workflow.Create",
    update: "PagesAdministration.Workflow.Update",
    read: "PagesAdministration.Workflow.Read",
    delete: "PagesAdministration.Workflow.Delete",
    detail: "PagesAdministration.Workflow.Detail",
    export: "PagesAdministration.Workflow.Export",
    import: "PagesAdministration.Workflow.Import",
  },

  approverGroup: {
    page: "PagesAdministration.ApproverGroup",
    read: "PagesAdministration.ApproverGroup.Read",
    create: "PagesAdministration.ApproverGroup.Create",
    update: "PagesAdministration.ApproverGroup.Update",
    delete: "PagesAdministration.ApproverGroup.Delete",
  },

  contractInquiry: {
    page: "PagesAdministration.ContractInquiry",
    create: "PagesAdministration.ContractInquiry.Create",
    update: "PagesAdministration.ContractInquiry.Update",
    delete: "PagesAdministration.ContractInquiry.Delete",
    read: "PagesAdministration.ContractInquiry.Read",
    accountingIntegration: "PagesAdministration.ContractInquiry.AccountingIntegration",
    invoiceIntegration: "PagesAdministration.ContractInquiry.InvoiceIntegration",
    viewInvoiceIntegration: "PagesAdministration.ContractInquiry.ViewInvoiceIntegration",
    import: "PagesAdministration.ContractInquiry.Import",
    export: "PagesAdministration.ContractInquiry.Export",
  },
  feeNotification: {
    page: "PagesAdministration.FeeNotification",
    create: "PagesAdministration.FeeNotification.Create",
    detail: "PagesAdministration.FeeNotification.Detail",
    read: "PagesAdministration.FeeNotification.Read",
    sendNotification: "PagesAdministration.FeeNotification.SendNotification",
    // P0-FEE-03: BE đã có PagesAdministration.FeeNotification.DeleteDetail nhưng FE thiếu mirror
    // nên nút xoá HĐ khỏi đợt không được gate. Bổ sung theo fee-notification-reporting R1.3.
    deleteDetail: "PagesAdministration.FeeNotification.DeleteDetail",
    setting: "PagesAdministration.FeeNotification.Setting",
  },
  notificationCenter: {
    // Parent permission for the Notification Center setting page (R6.7).
    page: "PagesAdministration.NotificationCenter",
    // Setting matrix permissions split by level, each with View + Edit (R6.7/6.8).
    setting: {
      generalView: "PagesAdministration.NotificationCenter.GeneralView",
      generalEdit: "PagesAdministration.NotificationCenter.GeneralEdit",
      projectView: "PagesAdministration.NotificationCenter.ProjectView",
      projectEdit: "PagesAdministration.NotificationCenter.ProjectEdit",
      userView: "PagesAdministration.NotificationCenter.UserView",
      userEdit: "PagesAdministration.NotificationCenter.UserEdit",
    },
  },
  BlockUser: {
    page: "PagesAdministration.BlockUser",
    block: "PagesAdministration.BlockUser.Block",
    unblock: "PagesAdministration.BlockUser.UnBlock",
  },
  configEntityProject: {
    page: "PagesAdministration.SystemConfiguration",
    read: "PagesAdministration.SystemConfiguration.ReadAccountingEntity",
    update: "PagesAdministration.SystemConfiguration.UpdateAccountingEntity"
  },
  report: {
    report: "PagesAdministration.Report",
    booking: "PagesAdministration.Report.Booking",
    dailyCollection: "PagesAdministration.Report.DailyCollection",       // fixed: was missing .Report.
    dailyCollectionExport: "PagesAdministration.Report.DailyCollection_Export",
    dueDate: "PagesAdministration.Report.DueDate",
    dueDateExport: "PagesAdministration.Report.DueDate_Export",
    quickCollection: "PagesAdministration.Report.QuickCollection",
    quickCollectionExport: "PagesAdministration.Report.QuickCollection_Export",
    saleStatus: "PagesAdministration.Report.SaleStatus",
    saleStatusExport: "PagesAdministration.Report.SaleStatus_Export",
    revenueStatement: "PagesAdministration.Report.RevenueStatement",
    revenueStatementExport: "PagesAdministration.Report.RevenueStatement_Export",
    debitNote: "PagesAdministration.Report.DebitNote",
    debitNoteExport: "PagesAdministration.Report.DebitNote_Export",
    aging: "PagesAdministration.Report.Aging",       // dùng chung cho arAging / agingSum / agingGroup
    agingExport: "PagesAdministration.Report.Aging_Export",
    // Lớp báo cáo Thông báo phí theo dự án (fee-notification-reporting R11.2):
    // dashboard, ma trận HĐ × kỳ phí, backlog, không gửi được, aging × bậc, gửi trùng.
    feeNotification: "PagesAdministration.Report.FeeNotification",
    feeNotificationExport: "PagesAdministration.Report.FeeNotification_Export",
  },
  numberingConfig: {
    page: "PagesAdministration.NumberingConfig",
    read: "PagesAdministration.NumberingConfig.Read",
    createOrUpdate: "PagesAdministration.NumberingConfig.CreateOrUpdate",
    /**
     * Sửa THẲNG số hiện tại của bộ đếm — tách khỏi `createOrUpdate` vì hạ số làm hệ thống cấp lại
     * mã đã phát hành. Permission mới chưa gán cho role nào, phải gán tay sau khi deploy.
     */
    updateLastNumber: "PagesAdministration.NumberingConfig.UpdateLastNumber",
  },
  /** Mẫu mã tự sinh (Feature-0371) — mẫu chuẩn của nghiệp vụ, khác bộ đếm ở numberingConfig. */
  codeFormatTemplate: {
    page: "PagesAdministration.CodeFormatTemplate",
    read: "PagesAdministration.CodeFormatTemplate.Read",
    createOrUpdate: "PagesAdministration.CodeFormatTemplate.CreateOrUpdate",
    delete: "PagesAdministration.CodeFormatTemplate.Delete",
  },
  configurationPaymentSchedule: {
    page: "PagesAdministration.ConfigurationPayment",
    read: "PagesAdministration.ConfigurationPayment.Read",
    create: "PagesAdministration.ConfigurationPayment.Create",
    update: "PagesAdministration.ConfigurationPayment.Update",
    delete: "PagesAdministration.ConfigurationPayment.Delete",
    detail: "PagesAdministration.ConfigurationPayment.Detail",
    viewFull: "PagesAdministration.ConfigurationPayment.ViewAll",
    import: "PagesAdministration.ConfigurationPayment.Import",
    export: "PagesAdministration.ConfigurationPayment.Export"
  },
  contractEvent: {
    page: "PagesAdministration.ContractEvent",
    read: "PagesAdministration.ContractEvent.Read",
    createUpdate: "PagesAdministration.ContractEvent.Create_Update",
    detail: "PagesAdministration.ContractEvent.Detail",
    print: "PagesAdministration.ContractEvent.Print",
    import: "PagesAdministration.ContractEvent.Import",
  },
  contractInterestSetting: {
    page: "PagesAdministration.ContractInterestSetting",
    read: "PagesAdministration.ContractInterestSetting.Read",
    createUpdate: "PagesAdministration.ContractInterestSetting.CreateOrUpdate",
    delete: "PagesAdministration.ContractInterestSetting.Delete",
  },
  managementFeeSetting: {
    page: "PagesAdministration.ManagementFeeSetting",
    read: "PagesAdministration.ManagementFeeSetting.Read",
    detail: "PagesAdministration.ManagementFeeSetting.Detail",
    create: "PagesAdministration.ManagementFeeSetting.Create",
    update: "PagesAdministration.ManagementFeeSetting.Update",
    delete: "PagesAdministration.ManagementFeeSetting.Delete",
  },
  debtDefaultSetting: {
    page: "PagesAdministration.DebtDefaultSetting",
    read: "PagesAdministration.DebtDefaultSetting.Read",
    detail: "PagesAdministration.DebtDefaultSetting.Detail",
    create: "PagesAdministration.DebtDefaultSetting.Create",
    update: "PagesAdministration.DebtDefaultSetting.Update",
    delete: "PagesAdministration.DebtDefaultSetting.Delete",
    import: "PagesAdministration.DebtDefaultSetting.Import",
  },
  // Feature-0369 — cấu hình tài khoản treo ("dòng ảo"). Mirror ĐÚNG hằng backend
  // (`Core/Authorization/AppPermissions.cs`); `page` là quyền cha mà AppService check ở class-level.
  suspenseAccountSetting: {
    page: "PagesAdministration.SuspenseAccountSetting",
    read: "PagesAdministration.SuspenseAccountSetting.Read",
    detail: "PagesAdministration.SuspenseAccountSetting.Detail",
    create: "PagesAdministration.SuspenseAccountSetting.Create",
    update: "PagesAdministration.SuspenseAccountSetting.Update",
    delete: "PagesAdministration.SuspenseAccountSetting.Delete",
  },
  integrationResult: {
    page: "PagesAdministration.IntegrationResult",
    read: "PagesAdministration.IntegrationResult.Read",
  },
  integrationHub: {
    page: "PagesAdministration.IntegrationHub",
    dashboard: "PagesAdministration.IntegrationHub.Dashboard",
    read: "PagesAdministration.IntegrationHub.Read",
    retry: "PagesAdministration.IntegrationHub.Retry",
    bulkRetry: "PagesAdministration.IntegrationHub.BulkRetry",
    dlq: "PagesAdministration.IntegrationHub.DLQ",
    configuration: "PagesAdministration.IntegrationHub.Configuration",
  }

}

// Administrative Level
export enum AdministrativeLevel {
  administrative_area_level_1 = "administrative_area_level_1",
  administrative_area_level_2 = "administrative_area_level_2",
  administrative_area_level_3 = "administrative_area_level_3",
  undefined = "undefined",
}

// Notification
export const notificationTypes = {
  text: 1,
  download: 2,
  gotoDetail: 3,
}

export const sendNotificationMethos = {
  mail: 1,
  sms: 2,
  both: 3,
}

export const statusSendNotification = [
  {
    type: "PENDING",
    name: "PENDING",
    color: "#2F80ED",
    backgroundColors: "#E3EEFD",
  },
  { type: "SENT", name: "SENT", color: "#27AE60", backgroundColors: "#E6F9EE" },
  {
    type: "FAILED",
    name: "FAILED",
    color: "#EB5757",
    backgroundColors: "#FCE4E4",
  },
]

// fileType
export const fileTypeGroup = {
  pdf: [".pdf"],
  images: [".png", ".jpg", ".jpeg"],
  office: [".xls", ".xlsx", ".doc", ".docx"],
  msg: [".msg"],
  documents: [".csv", ".xls", ".xlsx", ".pdf", ".doc", ".docx"],
  documentAndImage: [
    ".csv",
    ".xls",
    ".xlsx",
    ".pdf",
    ".doc",
    ".docx",
    ".png",
    ".jpg",
    ".jpeg",
    ".msg",
  ],
}

// Layout constant
export const themeByEvent = {
  events: {
    default: "default",
    xmasSanta: "xmas-santa",
    xmasHouse: "xmas-house",
    xmasNight: "xmas-night",
    flowers: "flowers",
  },
}

export const retrieveTypes = {
  administrative_area_level_1: ["(cities)"],
  administrative_area_level_2: ["(regions)"],
  undefined: [],
}

export const routeByModules = {
  [moduleIds.company]: "/company-detail/:id",
  [moduleIds.contact]: "/contact-detail/:id",
  [moduleIds.project]: "/project-detail/:id",
  [moduleIds.opportunity]: "/opportunity-detail/:id",
  [moduleIds.requirement]: "/requirement-detail/:id",
  [moduleIds.dealContract]: "/deal-contract-detail/:id",
  [moduleIds.accountant]: "/accountant-detail/:id",
}
export const MODULES = [
  { label: "COMPANY", value: moduleIds.company },
  { label: "CONTACT", value: moduleIds.contact },
  { label: "OPPORTUNITY", value: moduleIds.opportunity },
  { label: "PROJECT", value: moduleIds.project },
  { label: "DEAL", value: moduleIds.dealContract },
]
export const GENDERS = [
  { value: 1, label: "MAN" },
  { value: 2, label: "WOMAN" },
  { value: 3, label: "OTHER" },
]

export const GENDERS_STAFF = [
  { id: true, value: true, label: "MAN" },
  { id: false, value: false, label: "WOMAN" },
]

export const listDays = [
  {
    get label() {
      return L("{0}_DAYS", 7)
    },
    value: 7,
  },
  {
    get label() {
      return L("{0}_DAYS", 30)
    },
    value: 30,
  },
  {
    get label() {
      return L("{0}_DAYS", 60)
    },
    value: 60,
  },
  {
    get label() {
      return L("{0}_DAYS", 180)
    },
    value: 180,
  },
]
export const percentOptions = [
  { value: 0, label: "0%" },
  { value: 30, label: "30%" },
  { value: 50, label: "50%" },
  { value: 70, label: "70%" },
  { value: 100, label: "100%" },
]
export const rangePickerPlaceholder: any = () => {
  const label = [
    {
      get label() {
        return L("FROM_DATE")
      },
    },
    {
      get label() {
        return L("TO_DATE")
      },
    },
  ]
  return label.map((i: any) => i.label)
}

export const statusActiveMap = [
  {
    value: " ",
    get label() {
      return L("ALL")
    },
  },
  {
    value: "true",
    get label() {
      return L("ACTIVE")
    },
  },
  {
    value: "false",
    get label() {
      return L("DEACTIVATE")
    },
  },
]
/**
 * Đọc projectId đã chọn từ cookie/localStorage.
 * Dùng cho initial filter state trong các scene — không cần inject SessionStore.
 * Trả về number | undefined (undefined = "Tất cả dự án").
 */
export function getDefaultProjectId(): number | undefined {
  // Ưu tiên cookie (được set khi chọn project ở header)
  const fromCookie = abp?.utils?.getCookieValue?.(AppConsts.authorization.projectId)
  const fromStorage = localStorage.getItem(AppConsts.authorization.projectId)
  const raw = fromCookie || fromStorage
  const parsed = parseInt(raw || "0")
  return parsed > 0 ? parsed : undefined
}

export default AppConsts
